import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
    @font-face {
        font-family: "Proxima Nova";
        src: url("https://cdn.reeltime.no/pm_assets/fonts/ProximaNova-Light.otf") format("otf"),
            url("https://cdn.reeltime.no/pm_assets/fonts/ProximaNova-Reg.otf") format("otf"),
            url("https://cdn.reeltime.no/pm_assets/fonts/ProximaNova-Bold.otf") format("otf"),
            url("https://cdn.reeltime.no/pm_assets/fonts/ProximaNova-Sbold.otf") format("otf");
    }

    * {
        font-family: 'Proxima Nova', sans-serif;
        box-sizing: border-box;
    }
    body {
        padding: 0;
        margin: 0;
        background: black;
    }
`;
